var _defs, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _polygon2, _polygon3, _polygon4, _polygon5, _path, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBarieraTermica(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f4f805d8-7fd4-4c55-8232-3061992855cb",
    "data-name": "bariera_termica",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174.56 200.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aa4256c2-4ed9-4a88-829a-de8c550184a1{fill-rule:evenodd;}.bcb88f66-0456-423b-9b7c-15fffbea7014,.e322bf86-8446-4846-801e-0cba98ec2d92,.eef1b353-359f-4fd1-ba95-d0464e0da946,.fddc9c96-c144-4fd1-a01e-45dd9b64e847{fill:none;stroke:#000;stroke-miterlimit:10;}.fddc9c96-c144-4fd1-a01e-45dd9b64e847{stroke-width:8px;}.e322bf86-8446-4846-801e-0cba98ec2d92{stroke-width:5px;}.eef1b353-359f-4fd1-ba95-d0464e0da946{stroke-width:3px;}.bcb88f66-0456-423b-9b7c-15fffbea7014{stroke-width:10px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bariera_termica") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "aa4256c2-4ed9-4a88-829a-de8c550184a1",
    points: "64.56 135.9 29.2 100.54 64.56 65.19 64.56 100.54 64.56 135.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 64.56,
    y1: 100.54,
    x2: 20.06,
    y2: 56.04
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 37.56,
    y1: 73.29,
    x2: 37.56,
    y2: 47.79
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 37.06,
    y1: 59.04,
    x2: 29.56,
    y2: 51.54
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 38.56,
    y1: 59.04,
    x2: 46.06,
    y2: 51.54
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 38.06,
    y1: 74.29,
    x2: 12.56,
    y2: 74.29
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 23.81,
    y1: 74.79,
    x2: 16.31,
    y2: 82.29
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 23.81,
    y1: 73.29,
    x2: 16.31,
    y2: 65.79
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 5.56,
    y1: 57.04,
    x2: 20.56,
    y2: 57.04
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 6.06,
    y1: 57.04,
    x2: 1.06,
    y2: 62.04
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 6.06,
    y1: 57.04,
    x2: 1.06,
    y2: 52.04
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 20.81,
    y1: 41.79,
    x2: 20.81,
    y2: 56.79
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 20.81,
    y1: 42.29,
    x2: 15.81,
    y2: 37.29
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 20.81,
    y1: 42.29,
    x2: 25.81,
    y2: 37.29
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 64.56,
    y1: 99.54,
    x2: 20.06,
    y2: 144.04
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 37.56,
    y1: 126.79,
    x2: 37.56,
    y2: 152.29
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 37.06,
    y1: 141.04,
    x2: 29.56,
    y2: 148.54
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 38.56,
    y1: 141.04,
    x2: 46.06,
    y2: 148.54
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 38.06,
    y1: 125.79,
    x2: 12.56,
    y2: 125.79
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 23.81,
    y1: 125.29,
    x2: 16.31,
    y2: 117.79
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 23.81,
    y1: 126.79,
    x2: 16.31,
    y2: 134.29
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 5.56,
    y1: 143.04,
    x2: 20.56,
    y2: 143.04
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 6.06,
    y1: 143.04,
    x2: 1.06,
    y2: 138.04
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 6.06,
    y1: 143.04,
    x2: 1.06,
    y2: 148.04
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 20.81,
    y1: 158.29,
    x2: 20.81,
    y2: 143.29
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 20.81,
    y1: 157.79,
    x2: 15.81,
    y2: 162.79
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "eef1b353-359f-4fd1-ba95-d0464e0da946",
    x1: 20.81,
    y1: 157.79,
    x2: 25.81,
    y2: 162.79
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 33.06,
    y1: 101.04,
    x2: 26.06,
    y2: 94.04
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "e322bf86-8446-4846-801e-0cba98ec2d92",
    x1: 33.06,
    y1: 100.04,
    x2: 26.06,
    y2: 107.04
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "bcb88f66-0456-423b-9b7c-15fffbea7014",
    x1: 64.56,
    y1: 200.04,
    x2: 64.56,
    y2: 0.04
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "bcb88f66-0456-423b-9b7c-15fffbea7014",
    x1: 104.56,
    y1: 200.04,
    x2: 104.56,
    y2: 0.04
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "aa4256c2-4ed9-4a88-829a-de8c550184a1",
    points: "64.35 177.39 64.35 200.04 85.12 200.04 103.71 189.31 103.71 154.67 64.35 177.39"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "aa4256c2-4ed9-4a88-829a-de8c550184a1",
    points: "64.35 121.39 64.35 156.03 103.71 133.31 103.71 98.67 64.35 121.39"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "aa4256c2-4ed9-4a88-829a-de8c550184a1",
    points: "64.35 67.39 64.35 102.03 103.71 79.31 103.71 44.67 64.35 67.39"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "aa4256c2-4ed9-4a88-829a-de8c550184a1",
    points: "84.08 0 64.35 11.39 64.35 46.03 103.71 23.31 103.71 0 84.08 0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125,65a36.13,36.13,0,0,0-4.79.33v69.34A36.13,36.13,0,0,0,125,135a35,35,0,0,0,0-70Z",
    transform: "translate(-15.44 0.04)"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.56,
    y1: 100.04,
    x2: 174.56,
    y2: 100.04
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.02,
    y1: 100.66,
    x2: 170.1,
    y2: 78.43
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.66,
    y1: 100.43,
    x2: 159.46,
    y2: 58.65
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.31,
    y1: 99.69,
    x2: 141.81,
    y2: 43.4
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 108.92,
    y1: 99.55,
    x2: 120.2,
    y2: 35.54
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.56,
    y1: 100.15,
    x2: 174.56,
    y2: 100.15
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.02,
    y1: 99.54,
    x2: 170.1,
    y2: 121.77
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.66,
    y1: 99.76,
    x2: 159.46,
    y2: 141.54
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 109.31,
    y1: 100.51,
    x2: 141.81,
    y2: 156.8
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "fddc9c96-c144-4fd1-a01e-45dd9b64e847",
    x1: 108.92,
    y1: 100.65,
    x2: 120.2,
    y2: 164.66
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarieraTermica);
export default __webpack_public_path__ + "static/media/bariera_termica.e7fc530c226d20435188f55b020b470e.svg";
export { ForwardRef as ReactComponent };